import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  title: {
    color: theme.palette.text.secondary,
    fontSize: 14
  },
  button: {
    marginLeft: 8,
    width: 120,
    color: "rgba(97, 198, 158, 1)",
    textTransform: "none",
    justifyContent: "left"
  },
  buttonEndIcon: {
    marginLeft: 4
  },
  popper: {
    width: 175,
    marginLeft: -8
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0
  },
  item: {
    paddingLeft: 14,
    fontSize: 14,
    height: 42,
    borderBottom: "1px solid #dddddd"
  },
  allTypesSelected: {
    color: "rgb(97, 198, 158)"
  },
  lastRaceSelected: {
    color: "#48769b"
  },
  customSelected: {
    color: "#998765"
  }
}));
